export default "__VITE_ASSET__CJOITroa__"